import { post } from './requests'

export const getDashboard = key =>
  post(['card-stack', 'dashboard'], { key, transformPayload: true })
